<template>
  <b-input-group>
    <input
      :type="is_enabled_to_show ? 'text' : 'password'"
      class="form-control"
      :value="value"
      @input="$emit('input', $event.target.value)"
      />
    <b-input-group-append>
      <b-button
        variant="outline-secondary"
        @focus="is_enabled_to_show = 1"
        @blur="is_enabled_to_show = 0"
        @click="is_enabled_to_show = 1 - is_enabled_to_show"
        >
        <i class="far fa-eye-slash fa-fw" v-if="is_enabled_to_show"></i>
        <i class="far fa-eye fa-fw" v-else></i>
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  props: [
    'value',
  ],
  data() {
    return {
      is_enabled_to_show: 0,
    }
  },
}
</script>

<style lang="scss">
</style>
